import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";
import { ResponseZCore } from "../models/response-zcore";

@Injectable()
export class OrmService {
  constructor(private http: HttpClient) {}

  get(
    schema: string,
    filter: any,
    sort: any,
    populate: any = {},
    tenant: any = null,
    limit: number = 1000,
    skip: number = 0,
    select: any = {}
  ) {
    return this.http.post<ResponseZCore>(environment.BASE_URL + "/orm/find", {
      schema,
      tenant,
      filter,
      select: {},
      sort,
      limit,
      skip,
      populate,
      secondsCache: 1,
    });
  }

  getOne(
    schema: string,
    filter: any,
    sort: any,
    populate: any = {},
    tenant: any = null
  ) {
    return this.http.post<ResponseZCore>(
      environment.BASE_URL + "/orm/find-one",
      {
        schema,
        tenant,
        filter,
        select: {},
        sort,
        populate,
        secondsCache: 1,
      }
    );
  }

  getById(
    schema: string,
    id: string,
    select: any = {},
    populate: any = {},
    tenant: any = null
  ) {
    return this.http.post<ResponseZCore>(
      environment.BASE_URL + "/orm/find-by-id",
      {
        schema,
        tenant,
        _id: id,
        select,
        populate,
        secondsCache: 1,
      }
    );
  }

  count(schema: string, filter: any) {
    return this.http.post<ResponseZCore>(environment.BASE_URL + "/orm/count", {
      schema,
      filter,
      secondsCache: 1,
    });
  }

  insert(schema: string, data: any) {
    return this.http.post<ResponseZCore>(environment.BASE_URL + "/orm/insert", {
      schema,
      data,
    });
  }

  insertTenant(schema: string, data: any, tenant: any = null) {
    return this.http.post<ResponseZCore>(environment.BASE_URL + "/orm/insert", {
      schema,
      tenant,
      data,
    });
  }

  updateTenant(schema: string, id: any, data: any, tenant: any = null) {
    return this.http.put<ResponseZCore>(environment.BASE_URL + "/orm/update", {
      schema,
      _id: id,
      tenant,
      data,
    });
  }
}
